"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keepFooterOnBottom = void 0;
function keepFooterOnBottom() {
    var _a;
    const wrapper = document.querySelector(".js-offcanvas-innerwrapper");
    const footer = document.querySelector("#js-footer");
    if (!wrapper || !footer)
        return;
    wrapper.style.position = "relative";
    wrapper.style.minHeight = "100vh";
    footer.style.position = "absolute";
    footer.style.bottom = "0";
    footer.style.width = "100%";
    let footerHeight = 0;
    const setWrapperPaddingBottom = () => {
        if (footerHeight !== footer.offsetHeight) {
            footerHeight = footer.offsetHeight;
            wrapper.style.paddingBottom = `${footerHeight}px`;
        }
    };
    (_a = document.querySelector(".c-main-content")) === null || _a === void 0 ? void 0 : _a.setAttribute("style", "min-height: unset;");
    setWrapperPaddingBottom();
    window.addEventListener("resize", setWrapperPaddingBottom);
}
exports.keepFooterOnBottom = keepFooterOnBottom;
